import React, { Fragment, useState } from "react";

const Success = ({ msg, setSuccessMsg }) => {
  const [isVisible, setSetIsVisible] = useState(true);
  return (
    <Fragment>
      {isVisible ? (
        <div className="message-box success pb-0 pt-o">
          <p>{msg}</p>
          <button
            className="close-btn"
            onClick={() => {
              setSetIsVisible(false);
              if (setSuccessMsg) {
                setSuccessMsg("");
              }
            }}
          >
            <span className="close_icon"></span>
          </button>
        </div>
      ) : null}
    </Fragment>
  );
};
export default Success;
